export default function isDOMReady() {
  return typeof window !== 'undefined' && typeof document !== 'undefined' && document.head;
}


//////////////////
// WEBPACK FOOTER
// ../component-library/node_modules/react-css-component/es/utils/isDOMReady.js
// module id = 797
// module chunks = 0